<template>
  <v-container>
    <v-layout>
      <v-flex>
        <v-layout xs4 mb-2>
          <v-flex mt-4>
            <h1>Gestão de Notificações</h1>
            <h3>
              Nova notificação > Notificação avulsa > Cadastro de notificação
              avulsa
            </h3>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <hr class="solid" />
    <v-layout>
      <v-row>
        <v-col cols="12">
          <v-stepper v-model="step">
            <v-stepper-header>
              <v-stepper-step step="1">
                Cotas
              </v-stepper-step>

              <v-divider></v-divider>

              <v-stepper-step step="2">
                Notificação
              </v-stepper-step>

              <v-divider></v-divider>

              <v-stepper-step step="3">
                Agendamento
              </v-stepper-step>
            </v-stepper-header>

            <v-stepper-items>
              <v-stepper-content step="1">
                <v-row>
                  <v-col cols="2" offset="10" class="text-right">
                    <v-btn
                        color="primary"
                        @click="step = 2"
                        :disabled="items.length === 0"
                    >
                      Prosseguir
                    </v-btn>
                  </v-col>
                </v-row>
                <hr class="solid" />
                <v-row>
                  <v-col cols="12">
                    <v-data-table :headers="headers" :items="items"
                                  :footer-props="{
                                    'items-per-page-options': [10, 25, 50, -1]
                                  }"
                                  :items-per-page="10">
                      <template v-slot:item="{ item }">
                        <tr>
                          <td>{{ item.nomeCliente }}</td>
                          <td>{{ item.grupo }}</td>
                          <td>{{ item.numeroCota }}</td>
                          <td>{{ item.cpfcnpj }}</td>
                          <td>
                            <v-btn
                                color="error"
                                fab
                                x-small
                                dark
                                title="Excluir"
                                @click="apagarCota(item)"
                            >
                              <v-icon>mdi-delete</v-icon>
                            </v-btn>
                          </td>
                        </tr>
                      </template>
                    </v-data-table>
                  </v-col>
                </v-row>
              </v-stepper-content>

              <v-stepper-content step="2">
                <v-form ref="form" @submit.prevent="prosseguir">
                  <v-row>
                    <v-col cols="2"
                    >
                      <v-btn color="error" @click="step = 1">
                        Voltar
                      </v-btn>
                    </v-col
                    >
                    <v-col cols="2" offset="3" class="text-center"
                    >
                      <v-btn
                          color="primary"
                          :disabled="notificacao.meioEnvio.length === 0"
                          @click="limpar()"
                      >
                        Limpar
                      </v-btn>
                    </v-col
                    >
                    <v-col cols="2" offset="3" class="text-right"
                    >
                      <v-btn
                          color="primary"
                          :disabled="notificacao.meioEnvio.length === 0"
                          type="submit"
                      >
                        Prosseguir
                      </v-btn>
                    </v-col
                    >
                  </v-row>
                  <hr class="solid" />
                  <v-row>
                    <v-col cols="12">
                      <v-alert
                          border="bottom"
                          colored-border
                          type="warning"
                          elevation="2"
                      >
                        O meio de envio da notificação é aplicado nas situações
                        em que um consorciado possuir mais de uma cota. Caso
                        notificado por "cota a cota", o mesmo irá receber 'n'
                        notificações para cada uma das suas cotas. Caso
                        notificado por "consorciado", o mesmo irá receber 1
                        notificação para todas suas cotas
                      </v-alert>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12">
                      Selecione o meio de envio da notificação:
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="11">
                      <v-radio-group v-model="notificacao.meioEnvio" row>
                        <v-radio label="Cota a Cota" value="1"></v-radio>
                        <v-radio label="Consorciado" value="2"></v-radio>
                      </v-radio-group>
                    </v-col>
                    <v-col cols="1">
                      <v-btn
                          color="primary"
                          fab
                          small
                          dark
                          @click="dialog = true"
                          :disabled="notificacao.meioEnvio.length === 0"
                      >
                        <v-icon>mdi-lightbulb</v-icon>
                      </v-btn>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12">
                      <v-text-field
                          label="Assunto"
                          placeholder="Assunto"
                          outlined
                          v-model="notificacao.assunto"
                          :disabled="notificacao.meioEnvio.length === 0"
                          :rules="[rules.required, rules.maxLegth100]"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12">
                      <v-text-field
                          outlined
                          name="input-7-4"
                          label="Corpo da Notificação"
                          v-model="notificacao.corpoNotificacao"
                          :disabled="notificacao.meioEnvio.length === 0"
                          :rules="[rules.required, rules.maxLegth150]"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-form>
              </v-stepper-content>

              <v-stepper-content step="3">
                <v-form ref="formFinal" @submit.prevent="salvar">
                  <v-row>
                    <v-col cols="2"
                    >
                      <v-btn color="error" @click="step = 2">
                        Voltar
                      </v-btn>
                    </v-col
                    >
                    <v-col cols="2" offset="3" class="text-center"
                    >
                      <v-btn color="primary" @click="limparProgramacao()">
                        Limpar
                      </v-btn>
                    </v-col
                    >
                    <v-col cols="2" offset="3" class="text-right"
                    >
                      <v-btn color="primary" type="submit">
                        Salvar
                      </v-btn>
                    </v-col
                    >
                  </v-row>
                  <hr class="solid" />
                  <v-row>
                    <v-col cols="2">
                      <v-textarea
                          label="Meio de Envio"
                          :value="
                            notificacao.meioEnvio === '1'
                              ? 'Cota a Cota'
                              : 'Consorciado'
                          "
                          disabled
                          rows="2"
                      ></v-textarea>
                    </v-col>
                    <v-col cols="4">
                      <v-textarea
                          label="Assunto"
                          :value="notificacao.assunto"
                          disabled
                          rows="2"
                      ></v-textarea>
                    </v-col>
                    <v-col cols="6">
                      <v-textarea
                          label="Corpo da Mensagem"
                          :value="notificacao.corpoNotificacao"
                          disabled
                          rows="2"
                      ></v-textarea>
                    </v-col>
                  </v-row>
                  <h4>Programação de Envio</h4>
                  <v-row>
                    <v-col cols="5" class="mb-2">
                      <v-switch
                          v-model="notificacao.enviaImediatamente"
                          label="Enviar Imediatamente"
                          color="success"
                          hide-details
                          class="ml-2"
                      ></v-switch>
                    </v-col>
                  </v-row>
                  <v-row class="mt-2">
                    <v-col cols="3">
                      <v-text-field
                          label="Data"
                          placeholder="Data"
                          outlined
                          v-model="data"
                          :rules="
                            notificacao.enviaImediatamente ? [] : [rules.required]
                          "
                          type="date"
                          :disabled="notificacao.enviaImediatamente"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="2">
                      <v-text-field
                          label="Hora"
                          placeholder="Hora"
                          outlined
                          v-model="hora"
                          :rules="
                            notificacao.enviaImediatamente ? [] : [rules.required]
                          "
                          type="time"
                          :disabled="notificacao.enviaImediatamente"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="3">
                      <v-select
                          :items="acoes"
                          label="Ações da Notificação"
                          outlined
                          v-model="notificacao.acao"
                      ></v-select>
                    </v-col>
                    <v-col cols="9" v-if="notificacao.acao === '6'">
                      <v-text-field
                          label="Link Externo"
                          placeholder="Copie o link Aqui!"
                          outlined
                          v-model="notificacao.linkExterno"
                          :rules="
                            notificacao.acao === '6' ? [rules.required] : []
                          "
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-form>
              </v-stepper-content>
            </v-stepper-items>
          </v-stepper>
        </v-col>
      </v-row>
    </v-layout>
    <v-dialog v-model="dialog" persistent max-width="600px">
      <v-card>
        <v-card-title>Utilização de Variáveis</v-card-title>
        <hr class="solid" />
        <v-card-text>
          <v-row>
            <v-col cols="12">
              Utilize as seguintes variáveis no Assunto e Corpo da notificação
              para substituir com os dados da cota:
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-chip
                  class="ma-2"
                  color="green"
                  text-color="white"
                  v-for="v in variaveisPorMeioEnvio"
                  :key="v.texto"
                  @click="copiarVariavel(v.texto)"
              >
                {{ v.texto }}
              </v-chip>
            </v-col>
          </v-row>
          <v-row v-if="showCopiado">
            <v-col cols="12">
              <v-alert dense text type="success">
                Variável Copiada para Área de Transferência
              </v-alert>
            </v-col>
          </v-row>
        </v-card-text>
        <hr class="solid" />
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="dialog = false"> Fechar </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
  import Rules from '@/plugins/validation'
  import { alert } from '@/plugins/helpers'

  export default {
    name: 'NotificacaoAvulsa',
    data: () => ({
      step: 1,
      items: [],
      headers: [
        { text: 'Nome do Cliente', value: 'nomeCliente' },
        { text: 'Grupo', value: 'grupo' },
        { text: 'Cota', value: 'numeroCota' },
        { text: 'CPF/CNPJ', value: 'cpfcnpj' },
        { text: 'Ações', value: 'acao', sortable: false }
      ],
      notificacao: {
        id: 0,
        meioEnvio: '',
        assunto: '',
        corpoNotificacao: '',
        dataProgramadaEnvio: '',
        acao: '0',
        cotas: [],
        linkExterno: '',
        enviaImediatamente: false
      },
      dialog: false,
      variaveis: [
        { meioEnvio: '1', texto: '$nm_cliente_simples' },
        { meioEnvio: '1', texto: '$nm_cliente_completo' },
        { meioEnvio: '1', texto: '$grupo' },
        { meioEnvio: '1', texto: '$cota' },
        { meioEnvio: '1', texto: '$cpf/cnpj' },
        { meioEnvio: '1', texto: '$dt_vencimento_parcela' },
        { meioEnvio: '1', texto: '$dias_vencimento_parcela' },
        { meioEnvio: '1', texto: '$vl_proxima_parcela' },
        { meioEnvio: '1', texto: '$dt_vencimento_parcela_atrasada' },
        { meioEnvio: '1', texto: '$dias_atraso_parcela' },
        { meioEnvio: '1', texto: '$num_parc_vencida_atrasada' },
        { meioEnvio: '1', texto: '$num_parc_vencida' },
        { meioEnvio: '1', texto: '$vl_parc_vencida_atrasada' },
        { meioEnvio: '1', texto: '$vl_parc_atrasada' },
        { meioEnvio: '1', texto: '$dt_nasc_cliente' },
        { meioEnvio: '1', texto: '$qtd_parc_atraso' },
        { meioEnvio: '1', texto: '$idade_cota_anos' },
        { meioEnvio: '1', texto: '$dias_proxima_assembleia' },
        { meioEnvio: '1', texto: '$dias_ultima_assembleia' },
        { meioEnvio: '1', texto: '$produto' },
        { meioEnvio: '1', texto: '$dt_ultima_assembleia' },
        { meioEnvio: '1', texto: '$dt_vencimento_mais_atrasada' },
        { meioEnvio: '1', texto: '$quant_parcelas_pagas' },
        { meioEnvio: '2', texto: '$nm_cliente_simples' },
        { meioEnvio: '2', texto: '$nm_cliente_completo' }
      ],
      showCopiado: false,
      acoes: [
        { text: 'Nenhuma', value: '0' },
        { text: 'Abrir tela de Lance', value: '1' },
        { text: 'Abrir a tela de Boleto', value: '2' },
        { text: 'Abrir a tela de Imposto de Renda', value: '3' },
        { text: 'Abrir a tela inicial', value: '4' },
        { text: 'Abrir tela da central de notificações', value: '5' },
        { text: 'Abrir um link externo', value: '6' }
      ],
      data: '',
      hora: '',
      editar: false,
      cotas: []
    }),
    computed: {
      rules: () => Rules,
      variaveisPorMeioEnvio () {
        return this.variaveis.filter((x) => {
          return x.meioEnvio === this.notificacao.meioEnvio
        })
      }
    },
    mounted () {
      this.listarCotas()
    },
    created () {},
    methods: {
      listarCotas () {
        this.loading = true

        return this.$http
          .post('/Cota?offSet=0&limit=0', {})
          .then((res) => {
            this.cotas = []
            this.$nextTick(() => {
              this.cotas = res.data
              this.carregarCotas()
            })
          })
          .catch(() => {
          // cancel
          })
          .finally(() => {
            this.loading = false
          })
      },
      carregarCotas () {
        let editarNotificacao = window.localStorage.getItem('editarNotificacao')

        if (editarNotificacao !== null) {
          this.editar = true
          this.buscarNotificacaoID(editarNotificacao)
        } else { this.items = JSON.parse(window.localStorage.getItem('cotasIncluidas')) }
      },
      apagarCota (cota) {
        alert({
          text: `Deseja excluir esta cota da notificação?`,
          showCloseButton: true,
          img_topo: false,
          buttons: {
            Excluir: () => {
              this.items = this.items.filter((x) => {
                return x.id !== cota.id
              })

              if (this.items.length === 0) {
                window.localStorage.removeItem('cotasIncluidas')
                this.acessar(this.menuRoute('cotas'))
              } else {
                window.localStorage.setItem(
                  'cotasIncluidas',
                  JSON.stringify(this.items)
                )
              }
            },
            Cancelar: () => true
          }
        })
      },
      menuRoute (name) {
        try {
          const route = this.$router.resolve({ name }).route
          const selected = this.$route.path.startsWith(route.path)
          return route.matched.length
            ? { text: route.meta.title, to: route.path, selected }
            : { text: '// fixme' }
        } catch (e) {
          return false
        }
      },
      acessar (item) {
        if (item.click) {
          item.click()
        } else {
          try {
            if (this.$route.path !== item.to) {
              this.$router.push(item.to)
            }
          } catch (e) {
            return false
          }
        }
      },
      copiarVariavel (texto) {
        navigator.clipboard.writeText(texto)
        this.showCopiado = true
        setTimeout(() => (this.showCopiado = false), 2000)
      },
      limpar () {
        this.notificacao = {
          meioEnvio: '',
          assunto: '',
          corpo: ''
        }
      },
      limparProgramacao () {
        this.notificacao.enviaImediatamente = false
        this.notificacao.dataProgramadaEnvio = ''
        this.notificacao.acao = '0'
        this.notificacao.linkExterno = ''

        this.data = ''
        this.hora = ''
      },
      prosseguir () {
        if (this.$refs.form.validate()) {
          this.step = 3
        }
      },
      salvar () {
        if (this.$refs.formFinal.validate()) {
          this.notificacao.dataProgramadaEnvio = this.notificacao
            .enviaImediatamente
            ? null
            : this.data.split('-')[0] +
              '-' +
              this.data.split('-')[1] +
              '-' +
              this.data.split('-')[2] +
              'T' +
              this.hora
          this.notificacao.cotas = this.items.map((x) => parseInt(x.cotaID))
          this.notificacao.meioEnvio = parseInt(this.notificacao.meioEnvio)
          this.notificacao.acao = parseInt(this.notificacao.acao)

          if (this.editar) {
            this.$http
              .put('/notificacao/' + this.notificacao.id, this.notificacao)
              .then(() => {
                alert('Notificação atualizada com sucesso!')
              })
              .then(() => {
                window.localStorage.removeItem('cotasIncluidas')
                this.acessar(this.menuRoute('cotas'))
              })
              .catch(() => {
                error(null, 'Erro ao Atualizar Notificação')
              })
          } else {
            this.$http
              .post('/notificacao', this.notificacao)
              .then(() => {
                alert('Notificação criada com sucesso!')
              })
              .then(() => {
                window.localStorage.removeItem('cotasIncluidas')
                this.acessar(this.menuRoute('cotas'))
              })
              .catch(() => {
                error(null, 'Erro ao Cadastrar Notificação')
              })
          }
        }
      },

      buscarNotificacaoID (id) {
        this.loading = true

        return this.$http
          .get('/notificacao/' + id)
          .then((res) => {
            this.$nextTick(() => {
              this.notificacao = res.data

              this.notificacao.meioEnvio = this.notificacao.meioEnvio.toString()
              this.notificacao.acao = this.notificacao.acao.toString()
              this.data = this.notificacao.dataProgramadaEnvio.split('T')[0]
              this.hora = this.notificacao.dataProgramadaEnvio
                .split('T')[1]
                .substr(0, 5)
              this.notificacao.cotas.forEach((x) => {
                this.items.push(this.cotas.find((y) => y.id === x.cotaID))
              })

              window.localStorage.removeItem('editarNotificacao')
            })
          })
          .then(() => {
            this.notificacao.cotas = []
          })
          .catch(() => {
          // cancel
          })
          .finally(() => (this.loading = false))
      }
    }
  }
</script>
